/* eslint-disable prefer-promise-reject-errors */ /* eslint-disable function-paren-newline */ 'use strict';
var body = document.querySelector('body');
function createMessage(className, text) {
    var div = document.createElement('div');
    div.textContent = text;
    div.className = className;
    body.append(div);
}
var logo = body.querySelector('.logo');
var resolveFn;
var promise1 = new Promise(function(resolve) {
    resolveFn = resolve;
});
var promise2 = new Promise(function(resolve, reject) {
    setTimeout(function() {
        return reject();
    }, 3000);
});
promise1.then(function() {
    return createMessage('message', 'Promise was resolved!');
});
promise2.catch(function() {
    return createMessage('message error-message', 'Promise was rejected!');
});
logo.addEventListener('click', function() {
    resolveFn();
});

//# sourceMappingURL=js_promise_basic_DOM.80401f32.js.map
